import { useState } from "react";
import { Link } from "react-router";
import { Button } from "../components/ui/Button";
import { orderService } from "../services/orderService";
import { sellerService } from "../services/sellerService";

const sellerId = "pharm-olympic";

export function SellerInventoryPage() {
  const [, refresh] = useState(0);
  const listings = sellerService.listInventory(sellerId);
  const incoming = sellerService.listIncomingActivity(sellerId);
  const rerender = () => refresh(value => value + 1);

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm ">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="text-4xl font-black">Seller inventory</h1>
          <p className="mt-3 text-slate-600">Manage pharmacy inventory listings, drafts, and incoming buyer activity.</p>
        </div>
        <Button href="/seller/listings/new">Add listing</Button>
      </div>
      <div className="mt-6 grid gap-3">
        {listings.map(listing => (
          <Link className="rounded-2xl bg-slate-50 p-5 hover:bg-slate-100" key={listing.id} to={`/marketplace/listings/${listing.id}`}>
            <strong>{listing.name} {listing.dosage}</strong>
            <p className="text-slate-600">{listing.quantity} units · {listing.status.replace("_", " ")}</p>
          </Link>
        ))}
      </div>

      <div className="mt-8 rounded-2xl border border-slate-200 bg-slate-50 p-5">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <p className="text-xs font-black uppercase tracking-[.24em] text-slate-500">Seller inbox</p>
            <h2 className="mt-2 text-2xl font-black">Incoming offers & holds</h2>
          </div>
          <p className="text-sm font-bold text-slate-500">{incoming.bids.length} bids · {incoming.holdRequests.length} holds</p>
        </div>

        <div className="mt-5 grid gap-3 lg:grid-cols-2">
          {incoming.bids.map(bid => (
            <div className="rounded-2xl bg-slate-50 p-4" key={bid.id}>
              <strong>{bid.id}</strong>
              <p className="mt-1 text-sm text-slate-600">Bid · {bid.status} · {bid.listing.name}</p>
              <p className="mt-2 text-sm font-bold text-slate-950">{bid.quantity} unit @ ${bid.unitPrice.toLocaleString()} · expires {bid.expiresAt}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                <button className="rounded-xl bg-emerald-300 px-4 py-2 text-xs font-black text-slate-950" onClick={() => { orderService.acceptBid(bid.id); rerender(); }} type="button">Accept bid</button>
                <button className="rounded-xl border border-slate-200 bg-white px-4 py-2 text-xs font-black text-slate-950" onClick={() => { orderService.rejectBid(bid.id); rerender(); }} type="button">Reject bid</button>
              </div>
            </div>
          ))}

          {incoming.holdRequests.map(hold => (
            <div className="rounded-2xl bg-slate-50 p-4" key={hold.id}>
              <strong>{hold.id}</strong>
              <p className="mt-1 text-sm text-slate-600">Hold · {hold.status} · {hold.listing.name}</p>
              <p className="mt-2 text-sm font-bold text-slate-950">{hold.quantity} unit · {hold.holdHours} hour request</p>
              <div className="mt-4 flex flex-wrap gap-2">
                <button className="rounded-xl bg-emerald-300 px-4 py-2 text-xs font-black text-slate-950" onClick={() => { orderService.approveHoldRequest(hold.id); rerender(); }} type="button">Approve hold</button>
                <button className="rounded-xl border border-slate-200 bg-white px-4 py-2 text-xs font-black text-slate-950" onClick={() => { orderService.releaseHoldRequest(hold.id); rerender(); }} type="button">Release hold</button>
              </div>
            </div>
          ))}

          {incoming.bids.length === 0 && incoming.holdRequests.length === 0 ? (
            <p className="rounded-2xl bg-slate-50 p-4 text-sm font-semibold text-slate-500">No incoming bids or hold requests yet.</p>
          ) : null}
        </div>
      </div>
    </section>
  );
}
